import script from "./ModalDeleteUser.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalDeleteUser.vue?vue&type=script&setup=true&lang=js"

import "./ModalDeleteUser.vue?vue&type=style&index=0&id=7f356000&scoped=true&lang=scss"

import exportComponent from "/home/deployer/deploypad/silogues/releases/20261022152544/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f356000"]])

export default __exports__